export default {
    menu:{
        home: 'Home',
        about:'About',
        partners: 'Partners',
        contact:'Contact'
    },
    home:{
        aboutPPTitle:'About Privilege Program',
        aboutPPIntro:'Our Privilege Program offers endless fun and value for families!Through this program,\n' +
            '          you can use Monkey Coin to purchase avariety of exciting products and experiences, as well as dailynecessities,\n' +
            '          making your family time memorable and helping you save a lot!',
        aboutPPSmallText1:'Topping up Monkey Coin is now easier than ever!',
        aboutPPSmallText2:'Hong Kong’s best app for parents.',
        aboutPPSmallText3:'Over <span class="highlight-count">50+</span> kids-related merchants and benefits.',
        monkeyCoinTitle:'Enjoy the best discounts on activities and products.',
        'monkeyCoin-Excursion':'Excursion',
        'monkeyCoin-Fun':'Fun &<br> Entertainment',
        'monkeyCoin-Premiums':'Monkey Tree<br>Premiums',
        'monkeyCoin-Cash':'Cash<br>Voucher',
        'monkeyCoin-Gift':'Gift<br>Redemption',
        'monkeyCoin-Complimentary' :'Complimentary<br>Redemption',
        topUpCoinTitle:'Top Up Monkey Coin',
        topPicks:'Top Picks',
        'top-fun':'Fun & Entertainment',
        'top-fun-smallText':'Valued at $370',
        'top-excursion':'Excursion',
        'top-excursion-20':'20',
        'top-excursion-endText':'%Off',
        'top-cash':'Cash Voucher',
        learnMore:'Learn More...',
        'member-Registration':'Member Registration',
        'member-Registration-intro': 'Download the Monkey Tree App now and register as a member to enjoy exclusive benefits!',
        'video-Tutorial': 'Video Tutorial',
        'video-registration':'Registration',
        registration1:'Monkey Tree App\n Registration (Non-MT)',
        registration2:'Password\nRecovery',
        registration3:'Changing Language\nSettings',
        'video-redemption':'Redemption',
        redemption1:'Monkey Coin \n Top Up',
        redemption2:'Cash Vouchers \n Redemption',
        redemption3:'Gift \n Redemption',
        redemption4:'Complimentary \n Redemption',
        redemption5:'Fun & Entertainment \n Redemption',
    },
    common:{
        bottomBarText:'REGISTER NOW AND ENJOY SPECIAL BENEFITS!',
        close:'close',
    },
    footer:{
        address:'Suite 2514, 25/F,1111 King\'s Road. <br> Taikoo Shing, Hong Kong',
        email:'Email: enquiry@ppmember.com',
        tel:'Tel: (852) 3563-6771',
        siteMap:'Site Map',
        connect:'Connect',
        copyRight:'◎ Monkey Tree App. All rights reserved.',
        privacy:'Privacy Statement',
        termUse:'Terms of Use',
    },
    contact:{
        contactUs:'Contact Us',
        text:'Simply complete the contact form, and we will get back to you!',
        name:'Name:',
        email:'Email:',
        message:'Message:',
        submit:'Submit',
        tip1:'We are the sole owners of the information collected on this site. We only collect and have access to information that you voluntarily give us via email or other direct contact from you. We will not sell or rent this information to anyone.',
        tip2:'We will use your information to respond to you regarding the reason you contacted us. We will not share your information with any third party outside of our organisation, other than as necessary to fulfil your request.'
    },
    about:{
        contact:'Contact',
        socialMedia:'Social Media',
        down:'Download The Point App',
        mt:'Monkey Tree App',
        mtp1:'Download the app and instantly unlock a world of family perks—earn and top up Monkey Coins to redeem premium gifts and experiences,\n' +
            '              book curated outdoor and parentchild programs that enrich learning and bonding and grab deepdiscount cash vouchers and exclusive merchant offers for\n' +
            '              everyday savings. ',
        mtp2:"Enjoy membersonly promotions, seamless voucher redemption, secure payments, and easy management of orders and redemptions all\n" +
            "              in one place—making family time simpler, richer, and more rewarding.",
        AppFeatures:'App Features',
        features1:'Discover the enriching outdoor activities and parent–child programs',
        features2:'Top up Monkey Coins to redeem premium family and children’s gifts',
        features3:'Enjoy exclusive merchant offers for immediate savings',
        features4:'Practical cash vouchers available at deep discounts',
        downApp:'Download App',
        newFeatures3:'Exclusive Merchant Offers',
        newFeatureTitle1:'Discover the enriching outdoor activities and parent–child programs',
        newFeatureP1:'Explore curated field trips across Hong Kong — Ocean Park, Noah’s Ark, KMB Bus Depot,and more.' +
            '<br>Prefer hands‑on fun with your child? Join our parent–child workshops, including PizzaExpress pizza‑making and ice‑cream‑making sessions.' +
            '<br> Check out our full schedule and book your spot today.',
        newFeatureTitle2:'Top up Monkey Coins to redeem premium family and children’s gifts',
        newFeatureP2:'Choose from top‑up packs of 1,000 / 3,000 / 5,000 / 10,000 Monkey Coins. Redeem exclusives from Monkey Tree and partner brands, or exchange coins for attraction tickets across Hong Kong — Ocean Park Annual Passes, Jumping Gym credits, Joypolis Sport passes, Sandbox VR sessions, and more.',
        newFeatureTitle3:'Enjoy exclusive merchant offers for immediate savings',
        newFeatureP3:'We collaborate with 50+ trusted brands across Hong Kong. Simply show your app ID or redeem the code in our e‑shop to access 50+ discounts, including free kids’ meals, upgraded play packages, and lifestyle promotions.',
        newFeatureTitle4:'Practical cash vouchers available at deep discounts',
        newFeatureP4:'Find Hong Kong’s best deals on everyday vouchers through our app — ParknShop, Wellcome, 759 Store, Best Mart 360, Maxim’s Cakes, A1 Bakery and other popular retailers.'
    },
    partners:{
        partnerTitle:'Join Our Family',
        ourPartners:'Our Partners',
        ourPartnersIntro:'Turn your everyday activities into exciting rewards and unforgettable experiences with over 50 <br> local and worldwide travel and lifestyle ' +
            'partners, enhancing your product offerings.',
        partnerIntro:'As part of Hong Kong’s premier children-oriented rewards programme, Monkey Tree partners can access an exciting platform that showcases a wide ' +
            'range of kids’ activities and lifestyle options for our Hong Kong members.',
        opportunities:'Here are some of the opportunities our partners can enjoy:',
        opportunities1:'New business opportunities to connect with our Hong Kong customer base ',
        opportunities2:'Promotion of your brand through various communication channels',
        opportunities3:'Valuable data insights for enhanced decision-making',
        opportunities4:'Sustainable business success driven by our quality clientele',
        together:'Together, we explore new horizons…'
    }
}